"use strict";

angular.module("core")
.service("ProductCategoriesService", function($resource, appConfig) {
    var cache = null;
    var queryResource = $resource(appConfig.API_SERVER + "/auth/product-categories/", {
        "depth": 3
    }, {
        query: {
            method: "get",
            isArray: true,
            ignoreLoadingBar: true
        }
    });


    var currentCustomerResource = $resource(appConfig.API_SERVER + "/auth/customer/product-categories/", {
        "depth": 3
    }, {
        query: {
            method: "get",
            isArray: true,
            ignoreLoadingBar: true
        }
    });

    this.query = function() {
        if (cache === null) {
            cache = queryResource.query();
        }
        return cache;
    };

    this.currentCustomerQuery = function() {
        if (cache === null) {
            cache = currentCustomerResource.query();
        }
        return cache;
    };

    this.getIds = function(categories) {
        var categoryIds = [];
        angular.forEach(categories, function(value) {
            categoryIds.push(value.id);
        });
        return categoryIds;
    };

    this.getFilterIdParameter = function(categories) {
        return this.getIds(categories).join(",");
    };

    this.getSelectedCategories = function(selectedCategoryIds) {
        return currentCustomerResource.query({
            id: selectedCategoryIds[0],
            include_path: true
        });
    };
});



//////////////////
// WEBPACK FOOTER
// ./core/product-categories/product-categories.service.js
// module id = 425
// module chunks = 0